import {
  InvoiceStatus,
  ProductOrderDetailDTO,
  ProductOrderSummaryDTO,
  ProductStatus,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerProductApiType = ReturnType<typeof customerProductApi>;

const customerProductApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getList(params: {
      page: number;
      size: number;
      status?: ProductStatus;
      id?: number[];
      sort: string;
    }) {
      return axiosInstance.get(`${clubPrefix}product`, {
        params,
      });
    },
    findCategories(params: { page: number; size: number }) {
      return axiosInstance.put(`${clubPrefix}product/category/search`, params);
    },
    order(
      params: {
        paymentMethodId?: string;
        orderItems: ProductOrderDetailDTO[];
        promotionCode?: string;
        walletAmount?: number;
      },
      idempotencyKey: string,
    ) {
      return axiosInstance.put<{
        invoiceNumber: string;
        invoiceStatus: InvoiceStatus;
      }>(
        `${clubPrefix}customer/product-order-checkout/${idempotencyKey}`,
        params,
      );
    },

    summary(params: {
      productOrderList: ProductOrderDetailDTO[];
      promotionCode?: string;
    }) {
      return axiosInstance.post<ProductOrderSummaryDTO>(
        `${clubPrefix}product/order/summary`,
        params,
      );
    },
  };
};

export default customerProductApi;
